import { render, staticRenderFns } from "./AppAvatar.vue.js?vue&type=template&id=ee1dc576!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppAvatar.vue?vue&type=template&id=ee1dc576"
import script from "./AppAvatar.vue.js?vue&type=script&lang=js!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue.js?vue&type=script&lang=js!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppAvatar.vue?vue&type=script&lang=js"
import style0 from "./AppAvatar.vue.scss?vue&type=style&index=0&id=ee1dc576&lang=scss!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppAvatar.vue?vue&type=style&index=0&id=ee1dc576&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee1dc576')) {
      api.createRecord('ee1dc576', component.options)
    } else {
      api.reload('ee1dc576', component.options)
    }
    module.hot.accept("./AppAvatar.vue.js?vue&type=template&id=ee1dc576!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppAvatar.vue?vue&type=template&id=ee1dc576", function () {
      api.rerender('ee1dc576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppAvatar/AppAvatar.vue"
export default component.exports